import { Icon, Text, useIsMobile } from '@yes.technology/react-toolkit'
import { useRef } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { NavigationSliderSecondaryProps } from './NavigationSliderSecondary.types'
import { MainContainer, NavigationTitleContainer, SliderButton } from './styles'

function NavigationSliderSecondary({
  options,
  currentIndex,
  onNextClick,
  onPrevClick,
  disabled,
  disabledArrow,
  justifyContent = 'center',
  textVariant,
  iconSize,
  hasFixedNavigationButtonSize = false
}: NavigationSliderSecondaryProps) {
  const isMobile = useIsMobile()
  const { t } = useTranslation()
  const currentOption = options[currentIndex]
  const prevButtonRef = useRef<HTMLButtonElement>(null)
  const nextButtonRef = useRef<HTMLButtonElement>(null)

  const isArrowDisabled = (arrow: 'prev' | 'next') => {
    return disabled || disabledArrow === arrow
  }

  if (!currentOption) {
    return null
  }

  const { value, color, Adornment } = currentOption
  const previousLabel = `${value} - ${t('navigation-slider.previous')}`
  const nextLabel = `${value} - ${t('navigation-slider.next')}`

  const centerTextVariant =
    textVariant || (isMobile ? 'content-emphasis-03' : 'content-emphasis-06')
  const navigationIconSize = iconSize || (isMobile ? 'semiLarge' : 'extraLarge')

  return (
    <MainContainer $justifyContent={justifyContent}>
      <SliderButton
        onClick={onPrevClick}
        type='button'
        aria-label={previousLabel}
        disabled={isArrowDisabled('prev')}
        ref={prevButtonRef}
        onMouseEnter={() => prevButtonRef?.current?.focus()}
        onMouseLeave={() => prevButtonRef?.current?.blur()}
        $hasFixedSize={hasFixedNavigationButtonSize}
      >
        <Icon
          iconName={
            isArrowDisabled('prev')
              ? 'NavigationLeftDisabled'
              : 'NavigationLeft'
          }
          icSize={navigationIconSize}
          icColor='blackText'
          nonFocusable
        />
      </SliderButton>

      <NavigationTitleContainer>
        <Text
          variant={centerTextVariant}
          style={{
            textAlign: 'center',
            color: color || '#303032'
          }}
        >
          {value}
        </Text>
        {Adornment && Adornment}
      </NavigationTitleContainer>

      <SliderButton
        onClick={onNextClick}
        type='button'
        aria-label={nextLabel}
        disabled={isArrowDisabled('next')}
        ref={nextButtonRef}
        onMouseEnter={() => nextButtonRef?.current?.focus()}
        onMouseLeave={() => nextButtonRef?.current?.blur()}
        $hasFixedSize={hasFixedNavigationButtonSize}
      >
        <Icon
          iconName={
            isArrowDisabled('next')
              ? 'NavigationRightDisabled'
              : 'NavigationRight'
          }
          icSize={navigationIconSize}
          icColor='blackText'
          nonFocusable
        />
      </SliderButton>
    </MainContainer>
  )
}

export default NavigationSliderSecondary
